import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TextButtonRegularSmall as TextButton } from '@xingternal/malt-button';

import ModalInfo from './../../../Components/ModalInfo/ModalInfo';
import { CustomH, CustomP } from './../../../Components/CustomMalt/Typography';

import messages from './messages';

const FileUploadExpirationModal = () => (
  <ModalInfo>
    {(openModal, renderModalContent) => (
      <>
        <br />
        <TextButton onClick={openModal} noPadding>
          <FormattedMessage {...messages.fileUploadExpiration} />
        </TextButton>
        {renderModalContent(
          <>
            <CustomH>
              <FormattedMessage {...messages.fileUploadExpirationTitle} />
            </CustomH>
            <CustomP>
              <FormattedMessage {...messages.fileUploadExpirationParagraph} />
            </CustomP>
          </>
        )}
      </>
    )}
  </ModalInfo>
);

export default FileUploadExpirationModal;
